import {
    getUniqFieldId,
} from 'app/common/DomainObject'
import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'

import {
    DailyOpsFields,
} from '../dailyOps.types'

export default (name: string): SkyNetTableConfig<DailyOpsFields> => {
    return {
        tabs: [{
            name,
            url: CommonRoutes.All,
            fields: [
                {
                    name: 'orderNumber',
                    filterField: 'orderNumber',
                    filterType: FilterType.Array,
                    width: '100px',
                },
                {
                    name: 'from',
                    filterField: 'from',
                    filterType: FilterType.Array,
                    width: '100px',
                },
                {
                    name: 'to',
                    filterField: 'to',
                    filterType: FilterType.Array,
                    width: '100px',
                },
                {
                    name: 'customerLocationName',
                    filterField: 'customerLocationName',
                    filterType: FilterType.Array,
                },
                {
                    name: 'pricingAccountCompanyName',
                    filterField: 'pricingAccountCompanyName',
                    labelKey: 'Prebooking.pricingAccount',
                    filterType: FilterType.Array,
                },
                {
                    name: 'mawbNumber',
                    filterField: 'mawbNumber',
                    filterType: FilterType.Array,
                },
                {
                    name: 'baseLeaseUntilTimestamp',
                    filterField: 'baseLeaseUntilTimestamp',
                    filterType: FilterType.DateRange,
                    componentName: 'DateTimeCell',
                },
                {
                    name: 'baseLeaseUntilTimestamp',
                    componentName: 'ContainerSelectionUntil',
                    id: getUniqFieldId('baseLeaseUntilTimestamp', 1),
                    headerProps: {
                        children: 'Collection / Drop-off Point',
                    },
                    sorting: false,
                },
            ],
        }],
    }
}
